import React, { useContext, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";

import { faBookmark as faBookmarkSolid } from "@fortawesome/free-solid-svg-icons/faBookmark";
import { faBookmark as faBookmarkOutline } from "@fortawesome/free-regular-svg-icons/faBookmark";

import UserContext from "contexts/UserContext";
import UserApi from "@utils/api/UserApi";
import SocialShareButton from "./SocialShareButton";
// import useScreenSize from "hooks/useScreenSize";
import { getScreenSize, sizeEqualOrLessThan } from "utils/helpers";

export default function BookmarkButton(props) {
	const { article } = props;
	const { bookmarks, user, setBookmarks, loadingBookmarks, setLoadingBookmarks } = useContext(UserContext);
	const { getAccessTokenSilently, loginWithRedirect, isAuthenticated, isLoading } = useAuth0();

	// const { lessThan: smOrSmaller } = useScreenSize("sm");
	const smOrSmaller = sizeEqualOrLessThan("sm");

	const isBookmarked = bookmarks.find((b) => b.cmsid === article.sys.id);

	const addBookmark = async () => {
		setLoadingBookmarks(true);
		const token = await getAccessTokenSilently();

		const newBookmark = await UserApi.addBookmark(user, article, token);

		setBookmarks((bookmarks) => [...bookmarks, newBookmark]);
		setLoadingBookmarks(false);
	};

	const removeBookmark = async () => {
		setLoadingBookmarks(true);
		const token = await getAccessTokenSilently();

		const bookmarkRemoved = await UserApi.removeBookmark(user, isBookmarked, token);

		setBookmarks(bookmarks.filter((b) => b.id !== isBookmarked.id));
		setLoadingBookmarks(false);
	};
	return (
		<>
			{isBookmarked && (
				<SocialShareButton
					onClick={async () => await removeBookmark()}
					smOrSmaller={smOrSmaller}
					text="Bookmark"
					icon={faBookmarkSolid}
					loading={loadingBookmarks}
				/>
			)}
			{!isBookmarked && (
				<SocialShareButton
					disabled={!user}
					loading={loadingBookmarks}
					onClick={async () => await addBookmark()}
					smOrSmaller={smOrSmaller}
					text="Bookmark"
					icon={faBookmarkOutline}
				/>
			)}
		</>
	);
}
